import React from 'react';
import PropTypes from 'prop-types';
import { BackNavLink } from 'features/App';

const ListLink = ({ backUrl }) => <BackNavLink to={backUrl} />;

ListLink.propTypes = {
  backUrl: PropTypes.string,
};

export default ListLink;
